import { create } from "zustand";

/** One suggested table set inside ``tables_taken_on_revert`` 409.
 *  Each entry is a no-move group the operator can pick when the
 *  reservation's original mesas are taken. ``moves`` is populated by
 *  the backend only when a relocation plan can free the mesas — empty
 *  list otherwise. */
export interface RevertTablesSuggestion {
  table_ids: string[];
  table_names: string[];
  total_capacity: number;
  wasted_capacity: number;
  moves: Array<{
    reservation_id: string;
    guest_name: string;
    pax: number;
    to_table_ids: string[];
    to_table_names: string[];
  }>;
}

export interface RevertContext {
  detail: string;
  suggestions: RevertTablesSuggestion[];
  reservationLabel: string;
}

export interface RevertChoice {
  tables: string[];
  moves: RevertTablesSuggestion["moves"];
}

interface PendingRevert {
  context: RevertContext;
  resolve: (choice: RevertChoice | null) => void;
}

interface State {
  pending: PendingRevert | null;
  open: (context: RevertContext) => Promise<RevertChoice | null>;
  close: (choice: RevertChoice | null) => void;
}

export const useRevertTablesStore = create<State>((set, get) => ({
  pending: null,
  open: (context) =>
    new Promise<RevertChoice | null>((resolve) => {
      set({ pending: { context, resolve } });
    }),
  close: (choice) => {
    const { pending } = get();
    if (pending) {
      pending.resolve(choice);
      set({ pending: null });
    }
  },
}));
